export default `

    --body-padding: 1.5rem;
    --tb-row-spacer: 5px;

    // --------------
    // ---- space ---
    --space-xsm: 0.25rem;
    --space-sm: 0.5rem;
    --space:  0.75rem;
    --space-md: 1rem;
    --space-lg: 1.25rem;
    --space-xl: 2.5rem;
    --space-xxl: 4rem;

    --detail-block-padding: var(--space);

    // ---------------------
    // ---- Nav sidebar ----
    --nav-sidebar-padding-top: var(--space-sm);
    --nav-sidebar-padding-right: var(--space-lg);
    --nav-sidebar-padding-botom: var(--space-sm);
    --nav-sidebar-padding-left: var(--space-xl);

    // ---------------------
    // ---- Nav topbar ----
    --nav-topbar-padding: 1.5rem;

    // ---------------------------------------------------
    //---- Form group & Form group elements Variables ----
    --dropdown-arrow-position: 2.25rem;
    --horz-input-padding: var(--space);
    --form-input-radius: var(--space-xsm);
    --form-group-margin-bottom: var(--space-lg);
`;
